import { useEffect, useState } from "react";
import { gsap } from "gsap";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";

import bg from "../assets/home_img.png";
import useWindowDimensions from "../hooks/useWindowDimensions";

const Home = () => {
  const { width } = useWindowDimensions();

  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from("#home-h", {
        stagger: 0.1,
        opacity: 0,
        delay: 0.2,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from("#home-btn", {
        opacity: 0,
        duration: 0.1,
        y: 50,
      });

      setAnimated(!animated);
    }
  }, [inView]);

  return (
    <div ref={ref} id="home" className="min-vh-100">
      <div className="centered">
        <div
          id="home-h"
          style={{
            fontSize: width > 900 ? 70 : 42,
            color: "var(--primary)",
          }}
        >
          <h1 className="primary-h">Gutter Bats Planet</h1>
        </div>

        <br />
        <Link to="/purchase" style={{ all: "unset" }}>
          <button id="home-btn" className="primary-btn">
            Purchase Now
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Home;
